var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersTitleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_1877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9166 31.25V28.0833C27.9166 26.4036 27.2493 24.7927 26.0616 23.605C24.8739 22.4173 23.263 21.75 21.5833 21.75H8.91659C7.23688 21.75 5.62597 22.4173 4.43824 23.605C3.25051 24.7927 2.58325 26.4036 2.58325 28.0833V31.25",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2501 15.4167C18.7479 15.4167 21.5834 12.5811 21.5834 9.08333C21.5834 5.58553 18.7479 2.75 15.2501 2.75C11.7523 2.75 8.91675 5.58553 8.91675 9.08333C8.91675 12.5811 11.7523 15.4167 15.2501 15.4167Z",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4167 31.25V28.0833C37.4157 26.68 36.9486 25.3169 36.0889 24.2078C35.2292 23.0988 34.0255 22.3066 32.6667 21.9558",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 2.95581C27.6956 3.30462 28.9031 4.09692 29.7653 5.2078C30.6276 6.31868 31.0957 7.68496 31.0957 9.09123C31.0957 10.4975 30.6276 11.8638 29.7653 12.9747C28.9031 14.0855 27.6956 14.8778 26.3333 15.2266",
    stroke: "#3A3A3A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_1877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersTitleIcon);
export default __webpack_public_path__ + "static/media/users_title_icon.90dc9269d97130c6abddf51f6bdcdcff.svg";
export { ForwardRef as ReactComponent };